import React, { Fragment, useState, useEffect } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import axios from 'axios';
import { get, isEmpty } from 'lodash';
import FileUploader from '../../uploader/Modal';
import ErrorMessage from './errorMessage';
import { handleResponseCode } from '../../actions/index';
import { HHAlert, hlog } from '../../common/util';
import { ALERT_TYPE } from '../../common/constant';
import { PUBLIC_BUCKET_CDN, POST_UPLOAD_ACTION } from '../../network/api';

const HHTinyMCE = ({ field, form: { touched, errors, setFieldValue }, ...otherProps }) => {
  const [initialVal, setInitialVal] = useState('');
  const hasError = !!(touched[field.name] && errors[field.name]);

  useEffect(() => {
    setInitialVal(field.value ? field.value : '');
  }, []);

  const defaultConfig = {
    // selector: 'textarea', // not using select since this is will overwrite textarea into TinyMCM
    // placeholder not working
    // removed placeholder from plugin
    plugins: 'link image preview fullscreen media',
    language: localStorage.getItem('language') && localStorage.getItem('language').slice(0, 2) === 'zh-Hans' ? 'zh_CN' : 'en',
    toolbar: 'undo redo | bold italic | preview fullscreen | addImageBtn | media',
    entity_encoding: 'raw',
    setup: editor => {
      this.editor = editor;
      editor.addButton('addImageBtn', {
        text:
          localStorage.getItem('language') && localStorage.getItem('language').slice(0, 2) === 'zh'
            ? '上传照片'
            : 'Add Image',
        icon: 'image',
        onclick: () => {
          this.fu.handleOpen();
        }
      });
    }
  };

  const postUpload = async (parameter) => {
    try {
      const res = await axios.post(POST_UPLOAD_ACTION, parameter);
      const { code, response } = res.data;
      if (response && code === 200) {
        return response;
      }
      handleResponseCode(code);
      return {};
    } catch (err) {
      HHAlert({ id: 'alert.error.uploadFailed' }, ALERT_TYPE.ERROR);
      hlog(err);
      return {};
    }
  };

  const handleChange = async key => {
    const {
      userToken, slug, fileType, user, teamId
    } = otherProps;

    const username = get(user, 'profile.basicInfo.username', null);

    let parameter;
    if (username) {
      parameter = {
        token: userToken || user.token,
        files: [
          {
            objectKey: key,
            fileType,
            objectPathTemplateData: {
              eventSlug: slug,
              username
            }
          }
        ],
        eventSlug: slug,
        teamId
      };
    } else {
      parameter = {
        token: userToken || user.token,
        files: [
          {
            objectKey: key,
            fileType,
            objectPathTemplateData: {
              eventSlug: slug
            }
          }
        ],
        eventSlug: slug,
        teamId
      };
    }

    const res = await postUpload(parameter);
    if (isEmpty(res)) return;
    const newObjectKey = get(res, ['keysToAttributes', `${key}`, 'newObjectKey']);
    if (newObjectKey) {
      setTimeout(() => {
        this.editor.insertContent(`<img style='width: 100%;' src=${`${PUBLIC_BUCKET_CDN}${newObjectKey}`} referrerpolicy='no-referrer' />`);
      }, [1000]);
    }
  };


  return (
    <Fragment>
      <FileUploader
        accept='image/*'
        cropRatios={['free', '16:9', '1:1']}
        onChange={handleChange}
        {...otherProps}
        trigger={<div />}
        onRef={fu => { this.fu = fu; }}
      />
      <Editor
        initialValue={initialVal}
        value={field.value}
        onEditorChange={e => setFieldValue(field.name, e)}
        init={defaultConfig}
      />
      {hasError && (<ErrorMessage error={errors[field.name]} />)}
    </Fragment>
  );
};


export default HHTinyMCE;



// WEBPACK FOOTER //
// ./src/components/forms/fields/hhTinyMCE.js